/**
 * Mirror of backend/services/sku-generation.js LEGACY_BARCODE_TO_SKU_CONFIG
 * for client-side label barcode resolution. Keep in sync when mapping changes.
 */
export const LEGACY_BARCODE_TO_SKU_CONFIG = {
  'barcode_base_can.250': {
    containerType: 'can',
    unitType: '250',
    packType: '1',
    barcodeField: 'bn_unit',
  },
  'barcode_base_can.250.4': {
    containerType: 'can',
    unitType: '250',
    packType: '4',
    barcodeField: 'bn_pack',
  },
  'barcode_slab.250': {
    containerType: 'can',
    unitType: '250',
    packType: '1',
    barcodeField: 'bn_case',
    caseType: '24x1',
  },
  'barcode_slab.250.4': {
    containerType: 'can',
    unitType: '250',
    packType: '4',
    barcodeField: 'bn_case',
    caseType: '6x4',
  },

  'barcode_base_can.330': {
    containerType: 'can',
    unitType: '330',
    packType: '1',
    barcodeField: 'bn_unit',
  },
  'barcode_base_can.330.4': {
    containerType: 'can',
    unitType: '330',
    packType: '4',
    barcodeField: 'bn_pack',
  },
  'barcode_base_can.330.6': {
    containerType: 'can',
    unitType: '330',
    packType: '6',
    barcodeField: 'bn_pack',
  },
  'barcode_base_can.330.10': {
    containerType: 'can',
    unitType: '330',
    packType: '10',
    barcodeField: 'bn_pack',
  },
  'barcode_base_can.330.12': {
    containerType: 'can',
    unitType: '330',
    packType: '12',
    barcodeField: 'bn_pack',
  },
  'barcode_slab.24x.330': {
    containerType: 'can',
    unitType: '330',
    packType: '1',
    barcodeField: 'bn_case',
    caseType: '24x1',
  },
  'barcode_slab.16x.330': {
    containerType: 'can',
    unitType: '330',
    packType: '1',
    barcodeField: 'bn_case',
    caseType: '16x1',
  },
  'barcode_slab.330.4': {
    containerType: 'can',
    unitType: '330',
    packType: '4',
    barcodeField: 'bn_case',
    caseType: '6x4',
  },
  'barcode_slab.330.6': {
    containerType: 'can',
    unitType: '330',
    packType: '6',
    barcodeField: 'bn_case',
    caseType: '4x6',
  },
  'barcode_slab.330.10': {
    containerType: 'can',
    unitType: '330',
    packType: '10',
    barcodeField: 'bn_case',
  },
  'barcode_slab.330.12': {
    containerType: 'can',
    unitType: '330',
    packType: '12',
    barcodeField: 'bn_case',
    caseType: '2x12',
  },

  'barcode_base_can.375': {
    containerType: 'can',
    unitType: '375',
    packType: '1',
    barcodeField: 'bn_unit',
  },
  'barcode_slab.375': {
    containerType: 'can',
    unitType: '375',
    packType: '1',
    barcodeField: 'bn_case',
    caseType: '24x1',
  },

  'barcode_base_can.440': {
    containerType: 'can',
    unitType: '440',
    packType: '1',
    barcodeField: 'bn_unit',
  },
  'barcode_base_can.440.4': {
    containerType: 'can',
    unitType: '440',
    packType: '4',
    barcodeField: 'bn_pack',
  },
  'barcode_slab.15x.440': {
    containerType: 'can',
    unitType: '440',
    packType: '1',
    barcodeField: 'bn_case',
    caseType: '15x1',
  },
  'barcode_slab.16x.440': {
    containerType: 'can',
    unitType: '440',
    packType: '1',
    barcodeField: 'bn_case',
    caseType: '16x1',
  },
  'barcode_slab.24x.440': {
    containerType: 'can',
    unitType: '440',
    packType: '1',
    barcodeField: 'bn_case',
    caseType: '24x1',
  },
  'barcode_slab.440.4': {
    containerType: 'can',
    unitType: '440',
    packType: '4',
    barcodeField: 'bn_case',
    caseType: '6x4',
  },

  'barcode_base_bottle.330': {
    containerType: 'bottle',
    unitType: '330b',
    packType: '1',
    barcodeField: 'bn_unit',
  },
  'barcode_base_bottle.330.6': {
    containerType: 'bottle',
    unitType: '330b',
    packType: '6',
    barcodeField: 'bn_pack',
  },
  'barcode_case.330': {
    containerType: 'bottle',
    unitType: '330b',
    packType: '1',
    barcodeField: 'bn_case',
  },
  'barcode_case.330.6': {
    containerType: 'bottle',
    unitType: '330b',
    packType: '6',
    barcodeField: 'bn_case',
    caseType: '4x6',
  },

  'barcode_base_bottle.375': {
    containerType: 'bottle',
    unitType: '375',
    packType: '1',
    barcodeField: 'bn_unit',
  },
  'barcode_case.375': {
    containerType: 'bottle',
    unitType: '375',
    packType: '1',
    barcodeField: 'bn_case',
  },
  'barcode_case.375.6': {
    containerType: 'bottle',
    unitType: '375',
    packType: '6',
    barcodeField: 'bn_case',
    caseType: '4x6',
  },

  'barcode_base_bottle.650': {
    containerType: 'bottle',
    unitType: '650',
    packType: '1',
    barcodeField: 'bn_unit',
  },
  'barcode_case.650': {
    containerType: 'bottle',
    unitType: '650',
    packType: '1',
    barcodeField: 'bn_case',
  },

  'barcode_base_bottle.750': {
    containerType: 'bottle',
    unitType: '750',
    packType: '1',
    barcodeField: 'bn_unit',
  },
  'barcode_case.750': {
    containerType: 'bottle',
    unitType: '750',
    packType: '1',
    barcodeField: 'bn_case',
  },
  'barcode_case.750.12': {
    containerType: 'bottle',
    unitType: '750',
    packType: '1',
    barcodeField: 'bn_case',
    caseType: '12x1',
  },

  'barcode_keg.19.5': {
    containerType: 'keg',
    unitType: '19500',
    packType: '1',
    caseType: '1x1',
    barcodeField: 'bn_unit',
  },
  'barcode_keg.20': {
    containerType: 'keg',
    unitType: '20000',
    packType: '1',
    caseType: '1x1',
    barcodeField: 'bn_unit',
  },
  'barcode_keg.30': {
    containerType: 'keg',
    unitType: '30000',
    packType: '1',
    caseType: '1x1',
    barcodeField: 'bn_unit',
  },
  'barcode_keg.50': {
    containerType: 'keg',
    unitType: '50000',
    packType: '1',
    caseType: '1x1',
    barcodeField: 'bn_unit',
  },
};

const BN_TO_CAMEL = { bn_unit: 'bnUnit', bn_pack: 'bnPack', bn_case: 'bnCase' };

export function barcodeFieldToCamel(barcodeField) {
  return BN_TO_CAMEL[barcodeField] || barcodeField;
}
